import { render, staticRenderFns } from "./Dispatcher.vue?vue&type=template&id=54f03603&scoped=true&"
import script from "./Dispatcher.vue?vue&type=script&lang=js&"
export * from "./Dispatcher.vue?vue&type=script&lang=js&"
import style0 from "./Dispatcher.vue?vue&type=style&index=0&id=54f03603&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f03603",
  null
  
)

export default component.exports